import styled, {css} from "styled-components";

interface ILiveStreamingOverlayItemDefaultBoxProps {
    capsule?: boolean;
    transparent?: boolean;
}

export const LiveStreamingOverlayItemDefaultBox = styled.div<ILiveStreamingOverlayItemDefaultBoxProps>`
    display: flex;
    background: ${({theme, transparent}) => !transparent && theme.colors.bodyBackground.toString()};


    ${({capsule}) => !capsule ? css`
        padding: 2px;
        border-radius: 4px;
    ` : css`
        padding: 0 0.25rem;
        border-radius: 2rem;
    `}
`;
